require('./bootstrap');

require('alpinejs');

require('./ckeditor');
